import { render, staticRenderFns } from "./TicketMedio.vue?vue&type=template&id=101fc856"
import script from "./TicketMedio.vue?vue&type=script&lang=js"
export * from "./TicketMedio.vue?vue&type=script&lang=js"
import style0 from "./TicketMedio.vue?vue&type=style&index=0&id=101fc856&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports